export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";